<dx-popup
    class="popup"
    [width]="300"
    [height]="200"
    [showTitle]="true"
    title="Print Label"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="true"
    (onHiding)="closing()"
    [(visible)]="popupVisible"
>
    <dxi-toolbar-item location="after">
        <dx-button text="Print" [disabled]="selectedPrinter === undefined" (click)="sendToPrinter()"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'" style="height: 100%;">
        <div class="dx-fieldset" *ngIf="popupVisible">
            <div class="dx-fieldset-header">Printer <dx-load-indicator style="margin-right: 4px" [visible]="LoadingPrinters" [height]="16" [width]="16"> </dx-load-indicator></div>
            <div class="dx-field">
                <dx-lookup [dataSource]="printers" displayExpr="name" (onValueChanged)="printerChanged($event)">
                    <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
                </dx-lookup>
            </div>
        </div>
    </div>
</dx-popup>
<dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
</dx-load-panel>
